<template>
    <form class="code-input">
        <span v-for="(codeNo, index) in codeArr"
            :key="index">
            <input type="text" pattern="\d*"  maxlength="1" 
                v-model="code[index]"
                @keyup="keyMonitor"
                @paste="pasteMonitor"
                ref="codeInputs"/>
        </span>
    </form>
</template>

<script>
const TabKeyCodes = [9],
    DeleteKeyCodes = [8, 46],
    ArrowKeyCode = [37, 39]

const DefaultCode = {
    '0': '',
    '1': '',
    '2': '',
    '3': '',
    '4': '',
    '5': ''
}

export default {
    name: 'code-input',

    props: ['value', 'reset'],

    watch: {
        value: function(newVal, oldVal) {
            if(newVal === '' && oldVal !== '') {
                this.code = {...DefaultCode}
                this.$emit('input', Object.values(this.code).join(''))
                this.$refs.codeInputs[0].focus()
            }
        }
    },

    mounted() {
        this.$refs.codeInputs[0].focus()
    },

    data() {
        return {
            codeArr: new Array(6),
            code: {...DefaultCode}
        }
    },

    methods: {
        /**
         * Special actions for keypresses
         * @param {Object} keyEvent
         */
        keyMonitor(keyEvent) {
            this.$emit('input', Object.values(this.code).join(''))
            const keyCode = keyEvent.keyCode
            if(keyCode === 13)
                this.$emit('next')
            if(!this.isValidCharacter(keyCode))
                return
            const keyIndex = this.$refs.codeInputs.findIndex((codeInput) => codeInput == keyEvent.target)
            if(keyIndex !== -1) {
                if(TabKeyCodes.includes(keyCode))
                    return
                else if(ArrowKeyCode.includes(keyCode)) {
                    const directionalIndex =  keyIndex + (keyCode === 39 ? 1 : -1)
                    if(directionalIndex >= 0 && directionalIndex <= 5) {
                        this.$refs.codeInputs[directionalIndex].focus()
                        if(this.code[directionalIndex] !== '')
                            this.$refs.codeInputs[directionalIndex].select()
                    }
                }
                else if(DeleteKeyCodes.includes(keyCode)) {
                    if(this.code[keyIndex] === '' && keyIndex > 0)
                        this.$refs.codeInputs[keyIndex - 1].focus()
                }
                else if(this.code[keyIndex] !== '' && keyIndex < 5) {
                    this.$refs.codeInputs[keyIndex + 1].focus()
                    if(this.code[keyIndex + 1] !== '')
                        this.$refs.codeInputs[keyIndex + 1].select()
                }
            }
        },
        /**
         * Special actions for pasting events
         */
        pasteMonitor(pasteEvent) {
            const pasteText = pasteEvent.clipboardData.getData("text")
            for(const codeNo in this.code)
                this.code[codeNo] = pasteText[codeNo]
            this.$refs.codeInputs[5].focus()
        },
        /**
         * Return true if tha keycode is a valid character to take action
         * @param {number} keycode
         * @returns {boolean}
         */
        isValidCharacter(keycode) {
            return (keycode > 47 && keycode < 58) || // number keys
                (keycode > 64 && keycode < 91)    || // letter keys
                (keycode > 95 && keycode < 112)   || // numpad keys
                (keycode > 185 && keycode < 193)  || // ;=,-./` (in order)
                (keycode > 218 && keycode < 223)  ||   // [\]' (in order)
                [...TabKeyCodes, ...DeleteKeyCodes, ...ArrowKeyCode].includes(keycode)

        }
    }


}
</script>

<style lang="scss" scoped>
.code-input {
    margin-top: 8px;
    margin-bottom: 4px;
    display: flex;
    span {
        padding-right: 8px;
        input {
            width: 30px;
            height: 44px;
            font-size: 22px;
            text-align: center;
            border: 1px solid #cccccc;
            -moz-appearance: textfield;
            transition: border-color 0.5s ease;
            border-radius: 4px;
            font-weight: 600;
        }
        input:focus {
            outline: none;
            border-color: #2d3e4f;
        }
        // input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
        //     -webkit-appearance: none;
        // }
    }
}
</style>